import { render } from "./SelectPhotoModal.vue?vue&type=template&id=d9087b20"
import script from "./SelectPhotoModal.vue?vue&type=script&lang=js"
export * from "./SelectPhotoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__